<div class="flex flex-col h-[100vh]">
  @if (isServiceUnavailable) {
  <dc-maintenance-page></dc-maintenance-page>
  } @else {
  <div
    class="header-panel-overlay"
    [class.header-panel-overlay-visible]="isHeaderPanelVisible"
    [class.no-transition]="isInitialLoad"
    [class.active]="isDocumentDetailsRoute">
    <dc-header></dc-header>
    <dc-breadcrumb></dc-breadcrumb>
  </div>
  <!-- Schatten-Container nur für Detailseite -->
  @if (isDocumentDetailsRoute) {
  <div
    class="header-panel-shadow"
    [class.header-panel-shadow-visible]="isHeaderPanelVisible"
    [class.no-transition]="isInitialLoad"></div>
  }
  <!-- Toggle-Leiste nur für Detailseite -->
  @if (isDocumentDetailsRoute) {
  <div
    class="header-panel-buttons"
    [class.collapsed]="!isLeftOffCanvasOpen && !isMobile"
    [class.header-visible]="isHeaderPanelVisible"
    [class.no-transition]="isInitialLoad">
    @if (!isHeaderPanelVisible || isMobile) {
    <button
      class="header-panel-action-btn"
      [class.header-panel-action-btn-with-divider]="isMobile"
      [disabled]="!canGoBack()"
      [scoTooltip]="'BACK' | translate"
      (click)="goBack()">
      <i class="bi bi-arrow-left"></i>
    </button>
    } @if (!isHeaderPanelVisible && !isMobile) {
    <button
      class="header-panel-action-btn header-panel-action-btn-with-divider"
      [scoTooltip]="'GO_TO_HOMEPAGE' | translate"
      [routerLink]="'/' | localize">
      <i class="bi bi-house"></i>
    </button>
    }
    <div
      class="header-panel-toggle-group"
      (click)="toggleHeaderPanel()"
      [scoTooltip]="
        !isLeftOffCanvasOpen && !isMobile
          ? ((isHeaderPanelVisible ? 'HIDE_NAVIGATION' : 'SHOW_NAVIGATION') | translate)
          : ''
      ">
      <i [class]="isHeaderPanelVisible ? 'bi bi-chevron-bar-up' : 'bi bi-chevron-bar-down'"></i>
      @if (isLeftOffCanvasOpen || isMobile) {
      <span class="header-panel-toggle-text">
        {{ (isHeaderPanelVisible ? 'HIDE_NAVIGATION' : 'SHOW_NAVIGATION') | translate }}
      </span>
      }
    </div>
  </div>
  }
  <div class="grow h-full w-full flex overflow-auto shell">
    <router-outlet class="router-outlet"></router-outlet>
  </div>
  <dc-toast-notification></dc-toast-notification>
  }
</div>
